export default __webpack_public_path__ + "static/media/arrow-up-black.6d22fc0c.svg";